import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { Regiones } from "../Regiones";

const columns = () =>
(
    {
        c_region_id: new EntityColumn<string>({ name: 'c_region_id', type: 'char', length: 20, flags: c.PK, prompt: 'Region Id' }),
        c_area_id: new EntityColumn<string>({ name: 'c_area_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Area Id' }),
        vc_nombre_area: new EntityColumn<string>({ name: 'vc_nombre_area', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Nombre Area' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        area_brwStandard: { name: 'area_brwStandard', keyMappings: { c_area_id: 0 } }
    }
)

const lookups = () =>
(
    {
        'Regiones': {
            name: 'Regiones',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Regiones(client, parentKeys)
        },

    }
)

export class AreasDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();

    constructor() {
        super('Areas');
    }
}